webpackJsonp([263791100135453],{

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(331);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'static-page' },
	    _react2.default.createElement(
	      'h1',
	      null,
	      'About'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'body' },
	      _react2.default.createElement(
	        'p',
	        null,
	        'My name is Nicholas Jackson. I\'m a full time software developer for O\'Reilly Auto Parts. There, I do Java development for the eCommerce Operations team.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'I consider myself to be a cutting-edge developer that lives in the enterprise world. I love React, GraphQL, GatsbyJS (which is how this website is wrriten), and Javascript. I get to do very little of that at work (with good reason), so this is my outlet.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Outside of work, I play video games, learn about anything I find interesting (theology, economics, woodworking, etc.) and love to play the banjo.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'I\'m always looking for side jobs, so if you\'d be interested in hiring me, please ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: 'contact' },
	          'visit my contact page!'
	        )
	      )
	    )
	  );
	};
	
	exports.default = About;
	module.exports = exports['default'];

/***/ }),

/***/ 331:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-f8042862051df49288b7.js